import { useState } from 'react';
import { signOut } from 'aws-amplify/auth';
import { Button, Col, Container, Nav, Navbar, Offcanvas, Row } from "react-bootstrap"
import {
    Link,
    Outlet,
    useLocation,
} from "react-router-dom";
import logo from "../assets/CSEM_logo1.png";
import beyondLogo from "../assets/beyond_diagnostics.png";


function SidebarContent(props: {
    userAttributes: Map<string, string> | null,
    onLogout: () => void,
    pathname: string,
    onNavigate?: () => void,
}) {
    return (
        <Nav className="sidebar flex-column" activeKey={props.pathname}>
            <Nav.Item style={{ textAlign: 'center' }}>
                <img className="sidebar-logo-beyond" src={beyondLogo} alt="Beyond Diagnostics Logo" />
            </Nav.Item>
            <hr />
            <Nav.Item>
                <Nav.Link as={Link} to="/digiinsulin/capture" href="/digiinsulin/capture" onClick={props.onNavigate}>
                    <i className="bi bi-camera me-2" aria-hidden="true"></i>
                    Capture
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link as={Link} to="/digiinsulin" href="/digiinsulin" onClick={props.onNavigate}>
                    <i className="bi bi-clipboard2-data me-2" aria-hidden="true"></i>
                    Analysis Results
                </Nav.Link>
            </Nav.Item>
            <hr />
            <Nav.Item>
                <Navbar.Text>
                    {props.userAttributes?.get("name")} &nbsp;
                    <Button onClick={async () => {
                        await signOut();
                        props.onLogout();
                    }} variant='outline-primary' className="btn-sm"><i className="bi bi-box-arrow-right"></i></Button>
                </Navbar.Text>
            </Nav.Item>
            <Nav.Item style={{ textAlign: 'center', marginTop: 'auto', paddingBottom: '1rem' }}>
                <div style={{ fontSize: '0.65rem', color: '#999', marginBottom: '2px', letterSpacing: '0.03em' }}>Engineering partner</div>
                <img className="sidebar-logo-csem" src={logo} alt="CSEM Logo" />
            </Nav.Item>
        </Nav>
    );
}


export function Frame(props: { userAttributes: Map<string, string> | null, onLogout: () => void }) {
    const location = useLocation();
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    return <>
        {/* Mobile top bar — visible only below md breakpoint */}
        <Navbar className="d-md-none mobile-topbar" sticky="top">
            <Container fluid>
                <Button
                    variant="outline-light"
                    onClick={() => setShowOffcanvas(true)}
                    aria-label="Open navigation menu"
                >
                    <i className="bi bi-list"></i>
                </Button>
                <Navbar.Brand className="ms-2">
                    <img src={beyondLogo} alt="Beyond Diagnostics Logo" className="topbar-logo-beyond" />
                </Navbar.Brand>
            </Container>
        </Navbar>

        {/* Mobile offcanvas sidebar */}
        <Offcanvas
            show={showOffcanvas}
            onHide={() => setShowOffcanvas(false)}
            className="d-md-none"
            id="mobile-sidebar"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Navigation</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <SidebarContent
                    userAttributes={props.userAttributes}
                    onLogout={props.onLogout}
                    pathname={location.pathname}
                    onNavigate={() => setShowOffcanvas(false)}
                />
            </Offcanvas.Body>
        </Offcanvas>

        <Container fluid>
            <Row className="main-content-row">
                {/* Desktop sidebar — hidden below md */}
                <Col id="frame-container" className="d-none d-md-block">
                    <SidebarContent
                        userAttributes={props.userAttributes}
                        onLogout={props.onLogout}
                        pathname={location.pathname}
                    />
                </Col>
                <Col id="page-content-wrapper" style={{ flex: '1 1 0', minWidth: 0 }}>
                    <Outlet />
                </Col>
            </Row>
        </Container>
    </>

}